const setMetaTag = (selector, attributeName, attributeValue, content) => {
  if (!content) {
    return;
  }

  let tag = document.querySelector(selector);
  if (tag) {
    tag.setAttribute('content', content);
    return;
  }

  tag = document.createElement('meta');
  tag.setAttribute(attributeName, attributeValue);
  tag.setAttribute('content', content);
  document.head.appendChild(tag);
};

const setStructuredData = structuredData => {
  if (!structuredData) {
    return;
  }

  let script = document.querySelector('script[type="application/ld+json"]');
  if (!script) {
    script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(structuredData);
};

const normalizeCanonicalUrl = url => {
  if (!url || !url.startsWith('https://alharamaincab.com')) {
    return url;
  }

  const parsedUrl = new URL(url);
  const hasFileExtension = /\.[a-z0-9]+$/i.test(parsedUrl.pathname);

  if (!hasFileExtension && !parsedUrl.pathname.endsWith('/')) {
    parsedUrl.pathname = `${parsedUrl.pathname}/`;
  }

  return parsedUrl.toString();
};

const setLinkTag = (selector, rel, href, attributes = {}) => {
  if (!href) {
    return;
  }

  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement('link');
    tag.rel = rel;
    Object.entries(attributes).forEach(([key, value]) => {
      tag.setAttribute(key, value);
    });
    document.head.appendChild(tag);
  }

  tag.setAttribute('href', href);
};

export const setMeta = (title, description, canonicalUrl, imageUrl, options = {}) => {
  const { keywords, structuredData, type = 'website', locale = 'en', alternateUrl } = options || {};
  const normalizedCanonicalUrl = normalizeCanonicalUrl(canonicalUrl);
  const normalizedAlternateUrl = normalizeCanonicalUrl(alternateUrl);
  const isArabic = locale === 'ar';
  const selfHreflang = isArabic ? 'ar-SA' : 'en-US';
  const alternateHreflang = isArabic ? 'en-US' : 'ar-SA';
  const englishUrl = isArabic ? normalizedAlternateUrl : normalizedCanonicalUrl;

  if (title) {
    document.title = title;
  }
  
  if (description) {
    setMetaTag('meta[name="description"]', 'name', 'description', description);
  }

  if (keywords) {
    setMetaTag('meta[name="keywords"]', 'name', 'keywords', keywords);
  }
  
  if (normalizedCanonicalUrl) {
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) {
      linkCanonical.setAttribute('href', normalizedCanonicalUrl);
    } else {
      linkCanonical = document.createElement('link');
      linkCanonical.rel = "canonical";
      linkCanonical.href = normalizedCanonicalUrl;
      document.head.appendChild(linkCanonical);
    }
  }

  setMetaTag('meta[property="og:title"]', 'property', 'og:title', title);
  setMetaTag('meta[property="og:description"]', 'property', 'og:description', description);
  setMetaTag('meta[property="og:url"]', 'property', 'og:url', normalizedCanonicalUrl);
  setMetaTag('meta[property="og:type"]', 'property', 'og:type', type);
  setMetaTag('meta[property="og:locale"]', 'property', 'og:locale', isArabic ? 'ar_SA' : 'en_US');
  setMetaTag('meta[property="og:locale:alternate"]', 'property', 'og:locale:alternate', isArabic ? 'en_US' : 'ar_SA');
  setMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', title);
  setMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', description);
  setMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');

  if (imageUrl) {
    setMetaTag('meta[property="og:image"]', 'property', 'og:image', imageUrl);
    setMetaTag('meta[name="twitter:image"]', 'name', 'twitter:image', imageUrl);
  }

  setLinkTag(`link[rel="alternate"][hreflang="${selfHreflang}"]`, 'alternate', normalizedCanonicalUrl, {
    hreflang: selfHreflang,
  });
  if (normalizedAlternateUrl) {
    setLinkTag(`link[rel="alternate"][hreflang="${alternateHreflang}"]`, 'alternate', normalizedAlternateUrl, {
      hreflang: alternateHreflang,
    });
  }
  setLinkTag('link[rel="alternate"][hreflang="x-default"]', 'alternate', englishUrl || normalizedCanonicalUrl, {
    hreflang: 'x-default',
  });

  setStructuredData(structuredData);
};
